console.log('js/components/customer/resendEmail.js -> v0.1.0');

(() => {
	document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('resend-verification-email')) {
			resendVerificationEmailHandler(event);
    }

		if (event.target.classList.contains('resend-reset-password-email')) {
			resendResetPasswordEmail(event);
    }
  });

	function resendVerificationEmailHandler(event) {
		const link = event.target;
		const email = event.target.dataset.email;
		const csrfToken = event.target.dataset.csrfToken;

		const request = {
			'email': email
		}

		link.innerHTML = `<span>${resendEmailSendingText}</span>`;

		const params = {
			credentials: 'same-origin',
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken
			}
		}

		fetch("/account/auth/resend-verification", params)
		.then(function(response) {
			return response.json();
		})
		.then(function(response) {
			if (response.status == "ok") {
				link.outerHTML = `<span class="message-sent">✓ ${resendEmailSentText} </span>`;
			}
			else {
				link.outerHTML = `<span class="message-error"> ${response.error} </span>`;
			}
		})
		.catch(function(error) {
			console.error('Error:', error);
		});
	};

	function resendResetPasswordEmail(event) {
		const link = event.target;
		const email = event.target.dataset.email;
		const csrfToken = event.target.dataset.csrfToken;

		const request = {
			'email': email
		}

		link.innerHTML = `<span>${resendEmailSendingText}</span>`;

		const params = {
			method: 'POST',
			body: JSON.stringify(request),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken
			}
		}

		fetch("/account/auth/forgot-password", params)
		.then(function(response) {
			return response.json();
		})
		.then(function(response) {
			if (response.status == "ok") {
				link.outerHTML = `<span class="message-sent">✓ ${resendEmailSentText} </span>`;
			}
			else {
				link.outerHTML = `<span> ${response.error} </span>`;
			}
		})
		.catch(function(error) {
			console.error('Error:', error);
		});
	}
})();
